import { Keys } from '../types';

const keys: Keys = {
  alchemy: '1VD6qTLjeZYM5TusvbP6rYelZPycGcQV',
};

export default keys;
